import type { AppDispatch } from '@/app/store/store';
import { plpAdapter } from '../infra/adapters/plp.adapter';
import { createPlpService } from '../application/services/PlpService';
import { PhysicalStoreAdapter } from '@/shared/features/physical-store/infra/adapters/physicalStore.adapter';
import { SeoAdapter } from '@/shared/features/seo/infra/adapters/seo.adapter';

export function plpBuild(dispatch: AppDispatch) {
  const seoRepo = new SeoAdapter(dispatch);
  const repo = new plpAdapter(dispatch, seoRepo);
  const physicalStoreRepo = new PhysicalStoreAdapter(dispatch);
  const service = createPlpService(repo, physicalStoreRepo);
  return { service };
}

